const getMayorDiscount = product => {
    // Asi lo tiene hecho el loco, se podria simplificar pero paja
    let bonificacionFarmacia = product.precio1 * (1 - product.bonif1 / 100);
    return Math.trunc((1 - bonificacionFarmacia / product.precio2) * 100);
};

export default getMayorDiscount;
